import get from 'lodash/get'
import { fetch, update, remove } from 'app/utils/data'
import deserialize from 'app/utils/deserialize'

export default {
  namespaced: true,

  state: {
    item: {
      state: null
    }
  },

  getters: {
    state(state) {
      return get(state, ['item', 'state'])
    },

    username(state) {
      return get(state, ['item', 'login'])
    },

    active(state) {
      return get(state, ['item', 'active'], false)
    }
  },

  mutations: {
    fetched(state, { githubLink }) {
      state.item = githubLink
    },

    resetState(state) {
      state.item = { state: null }
    }
  },

  actions: {
    fetch({ commit }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: '/api/github-link',
          type: 'github-link'
        })
          .then((response) => {
            deserialize(response.data).then((githubLink) => {
              commit('fetched', { githubLink })
              resolve()
            })
          })
          .catch((_error) => {
            reject()
          })
      })
    },

    unlink({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        remove({
          url: '/api/github-link'
        })
          .then(() => dispatch('fetch'))
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    update({ commit, state: storeState }, { code, state }) {
      return new Promise((resolve, reject) => {
        update({
          url: `/api/github-link`,
          type: 'github-link',
          changes: {
            code,
            state
          },
          record: storeState.item
        })
          .then((response) => {
            deserialize(response.data).then((githubLink) => {
              commit('fetched', { githubLink })
              resolve()
            })
          })
          .catch((_error) => {
            reject()
          })
      })
    }
  }
}
